import useCapabilities, {
  DOMAIN,
  PERMISSION,
  useHasCapabilityBool,
  useRequireCapability
} from "@/hooks/useCapabilities";

export function usePersonMembershipAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonMembership = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonMembership
  });

  useRequireCapability({ domain: DOMAIN.PEOPLE, permission: PERMISSION.viewPersonMembership });

  return {
    loaded,
    canViewPersonMembership
  };
}
